import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers'
import * as yup from 'yup'

const SaveRuleAsSchema = yup
  .object()
  .shape({
    name: yup.string().required('Please add a name'),
  })
  .required()

export type TSaveRuleAsSchema = yup.InferType<typeof SaveRuleAsSchema>

export const useSaveRuleAsForm = ({ defaultValues = {}, ...props }) =>
  useForm<TSaveRuleAsSchema>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues,
    resolver: yupResolver(SaveRuleAsSchema),
    ...props,
  })
